"use client"

import { Link } from "@heroui/react";
import Image from 'next/image';
import DonorPortalUserNav from './dpusernav';
import { t } from '@lingui/core/macro';
import { useContext } from 'react';
import { LocaleContext } from '@/app/[lang]/intlprovider';
import { useUser } from './dpswr';
import { HomeIcon } from "@heroicons/react/24/solid";
import { usePathname, useRouter } from 'next/navigation';

export default function DonorPortalNavBar () {

    const [locale] = useContext( LocaleContext );

    const {user, isLoading, errorObject } = useUser();
    const pathname = usePathname();
    const userSignedIn = !isLoading && !!user;
    const hasUseUserError = ( errorObject !== undefined ) && ( errorObject !== null );
    const currentPath = pathname;

    const router = useRouter();

    if ( !userSignedIn && hasUseUserError && ( !pathname.includes( "signup" ) && !pathname.includes( "login" ) && !pathname.includes( "status" ) && ( pathname !== "/" + locale ) ) ) {
        void router.push( "/" + locale + "/login" );
    }

    return(
        <nav className="flex items-center justify-between w-full py-4 px-4 bg-kexp-light-layout-foreground sticky top-0 z-40 shadow-sm">
            <div>
                {
                    (userSignedIn) ? (
                        <Link href={"/" + locale + "/recent-giving"} isDisabled={currentPath === "/" + locale + "/recent-giving"}>
                            <HomeIcon
                                className="text-kexp-light-layout-background w-8 h-8"
                                width={32}
                                height={32}
                            />
                        </Link>
                    ) : (
                        <Link href={"https://kexp.org"} className="hover:opacity-75 transition-opacity">
                            <Image
                                className="-m-2"
                                src="/kexp-banner-primary-dark-1200x400.svg"
                                alt={t`KEXP Logo`}
                                width={150}
                                height={50}
                            />
                        </Link>
                    )
                }
            </div>
            <DonorPortalUserNav />
        </nav>
    );
}